// const greens = {
//   green5: '#46AD34',
//   green6: 'rgb(131, 217, 99)',
//   green7: 'rgb(155, 220, 125)',
// }
import { accents, purples } from './colors'

// const teal = {
//   teal5: 'rgb(65, 174, 166)',
// }

const focus = 'rgb(94 30 226 / 25%)'
const background = 'hsl(3 3% 99%)'

const light = {
  // Use zIndices
  zIndex: {
    sideBar: 2,
    chartNotice: 2,
    mainNav: 4,
    notFound: 5,
    modal: 11,
  },
  zIndices: {
    mainNav: 5,
    secondaryNav: 3,
    player: 4,
    menu: 51,
    toast: 100,
    tooltip: 22,
    modal: 21,
  },
  shadow: {
    'button': '0 1px 1px .5px rgba(0, 0, 0, .05)',
    'button-focus': `0px 0px 0px 4px ${focus}`,
    'button-secondary': '0px 3px 5px -1px rgba(0, 0, 0, .1)',
  },
  boxShadow: {
    shallow: '0px 3px 2px rgba(28, 28, 44, 0.06), 0px 2px 15px rgba(28, 28, 44, 0.07)',
    medium: '0px 10px 8px rgba(28, 28, 44, 0.06), 0px 8px 35px rgba(28, 28, 44, 0.07)',
    deep: '0px 10px 8px rgba(28, 28, 44, 0.06), 0px 30px 30px rgba(28, 28, 44, 0.07), 0px 70px 65px rgba(28, 28, 44, 0.09)',
  },
  breakpoints: ['40em', '52em', '64em', '80em'],
  colors: {
    'background': background,
    'background-primary': 'hsl(3 3% 95%)',
    'background-alt': accents.accent7,
    'modal-background': 'rgba(40, 40, 40, .7)',
    'tooltip-background': 'rgba(40, 40, 40, .9)',
    'success-background': 'rgba(93, 218, 114, .15)',
    'warning-background': 'rgb(255,242,198)',
    'input-background': 'white',
    'suggested-background': '#F9F9FA',
    'background-hover': '#f0f0f0',

    'audio-placement-indicator': '#C63200',
    'audio-navigator': 'rgba(255, 120, 75, 1)',
    'badge-bg': accents.accent7,
    'badge-success-bg': 'rgba(93, 218, 114, .15)',
    'badge-error-bg': 'rgb(255,242,198)',
    'scrollbar-bg': '#cccccc',
    'readonly-text-bg': '#eeeeee',

    'text': accents.accent1,
    'text-secondary': accents.accent4,
    'text-placeholder': accents.accent6,
    'link-secondary': accents.accent3,
    'text-select-background': focus,
    'error-text': 'rgb(206, 54, 92)',
    'success-text': 'rgba(12, 141, 27, 1)',

    'white': 'white',
    'blue': 'rgba(18, 115, 235, 1)',
    'light-blue': '#4BAFE8',

    'border-highlight': 'rgba(94, 30, 226, 1)',
    'box-shadow-highlight': focus,
    'border-color-light': '#e6e9eb',
    'border-color-dark': 'rgba(171, 171, 171, 1)',
    'border-color': 'hsl(214.3, 31.8%, 91.4%)',
    'border-color-input': '#999999',

    'tip-box-bg': ' rgba(47, 128, 237, 0.1)',
    'tip-box-color': ' rgb(87, 108, 187)',
    'pill-bg': accents.accent8,

    'search-background': accents.accent8,
    'search-background-focus': 'white',
    'search-text-color': accents.accent2,
    'search-text-placeholder-color': accents.accent4,
    'search-match-background': 'rgba(255, 217, 12, .5)',

    'option-hover-bg': accents.accent8,
    'option-checked-bg': purples.purple5,
    'option-checked-color': 'white',
    'option-checked-sub-color': 'rgba(255, 255, 255, .5)',

    // 'primary': teal.teal5,
    'primary': purples.purple5,
    'primary-dark': purples.purple6,
    'secondary': purples.purple6,
    'primary-light': purples.purple4,

    'menu': 'white',
    'menu-item-hover-bg': accents.accent8,
    'menu-item-hover-color': accents.accent2,

    /**
     * Pills
     */

    'pill-default-bg': accents.accent8,
    'pill-default-color': accents.accent4,

    'pill-success-bg': 'rgba(92, 197, 104, 0.15)',
    'pill-success-color': 'rgba(12, 141, 27, .8)',

    'pill-warning-bg': 'rgba(253, 211, 93, 0.3)',
    'pill-warning-color': 'rgba(101, 74, 1,.75)',

    'pill-error-bg': 'rgb(185, 0, 0, .15)',
    'pill-error-color': 'rgb(185, 0, 0)',

    'pill-input-bg': 'rgb(237,245, 250)',
    'pill-input-color': accents.accent2,

    /**
     * Icons
     */

    'icon-notice-color': 'rgb(0, 4, 185)',
    'icon-warning-color': 'rgb(244, 167, 0)',
    'icon-error-color': 'rgb(185, 0, 0)',
    'script-blurb-color': 'rgb(8, 165, 105)',
    'script-blurb-background': 'rgb(37, 174, 91, .13)',

    /**
     * Tables
     */
    'table-background': background,
    'table-header-background': '#F9F9FA',
    'table-header-color': accents.accent1,

    /**
     * Date Picker
     */
    'date-picker-preview-border-color': purples.purple6,
    'date-picker-passive': accents.accent7,

    /**
     * Toast
     */
    'toast-background': accents.accent2,
    'toast-color': accents.accent8,

    /**
     * Sentiment
     */
    'positive-sentiment': '#46AD34',
    'negative-sentiment': '#EB5160',
    'neutral-sentiment': accents.accent7,

    /**
     * Workflow
     */
    'variable-highlight-background': 'rgba(148, 255, 151, 0.3)',
    'variable-color': '#00A882',
    'entrypoint-color': '#8D80F2',
    'step-color': '#46D8A9',
    'action-bg': 'rgba(51, 97, 173, .15)',
    'action-color': '#335DAD',

    /**
     * Search Highlight
     */
    'search-highlight-background': '#FFD90C',
    'search-highlight-border': '#B89B00',

    /**
     * Radio
     */
    'selected': accents.accent1,

    ...accents,
  },
  fonts: {
    mono: "SFMono-Regular, Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  },
  fontSizes: {
    small: '.95em',
    h3: '1.1em',
    medium: '1.5em',
    large: '2em',
  },
  fontWeights: {
    light: 300,
    normal: 400,
    medium: 500,
    bold: 600,
  },
  weight: {
    normal: 400,
    medium: 500,
    bold: 600,
  },
  space: {
    xsmall: '3px',
    small: '6px',
    medium: '16px',
    large: '2em',
  },
  layout: {
    height: '70px',
    width: '1500px',
  },
  radii: {
    small: '3px',
    medium: '6px',
    large: '12px',
  },
  pill: {},

  input: {
    placeholder: accents.accent7,
    padding: '8px',
    tag: {
      background: 'rgba(51, 91, 173, .25)',
    },
    focus: {
      borderColor: 'rgba(64, 0, 156, 1)',
      boxShadow: `0px 0px 0px 4px ${focus}`,
      outlineWidth: '0',
    },
    invalid: {
      borderColor: 'rgb(206, 54, 92)',
      labelColor: 'rgb(206, 54, 92)',
    },
    invalidFocus: {
      borderColor: 'rgb(206, 54, 92)',
      boxShadow: '0px 0px 0 3px rgb(206 54 92 / 33%)',
    },
    readOnly: {
      background: accents.accent8,
    },
  },

  button: {
    mortal: {
      _base: {
        border: '1px solid',
      },
      secondary: {
        'background': background,
        'borderColor': 'hsl(214.3, 31.8%, 91.4%)',
        'color': accents.accent3,
        '&:hover': {
          boxShadow: '0 2px 4px rgba(0, 0, 0, .1)',
          borderColor: 'rgba(204, 204, 204, 1)',
        },
        ':disabled': {
          boxShadow: 'none',
        },
      },
      primary: {
        'background': purples.purple5,
        'borderColor': purples.purple5,
        'color': 'white',
        ':disabled': {
          background: 'transparent',
          color: accents.accent2,
          borderColor: accents.accent4,
          boxShadow: 'none',
        },
        ':active': {
          background: purples.purple6,
        },
      },
      dark: {
        background: accents.accent2,
        borderColor: accents.accent2,
        color: 'white',
      },
      danger: {
        background: 'rgb(211, 81, 75)',
        borderColor: 'rgb(211, 81, 75)',
        color: 'white',
      },
    },

    ghost: {
      _base: {
        background: 'transparent',
        border: '1px solid transparent',
      },

      secondary: {
        'color': accents.accent3,

        '&:hover': {
          background: accents.accent8,
          borderColor: accents.accent8,
        },
      },

      dark: {
        borderColor: accents.accent2,
        color: accents.accent2,
      },

      primary: {
        'color': purples.purple5,

        '&:hover': {
          background: purples.purple8,
          borderColor: purples.purple8,
        },
      },

      danger: {
        'color': 'rgb(211, 81, 75)',

        '&:hover': {
          background: 'rgba(211, 81, 75, .1)',
          borderColor: 'rgba(211, 81, 75, .1)',
        },
      },
    },
  },
}

export default light
